

























































import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'

import { Widget } from '../base/'
import BaseIcon from '../../../base/components/BaseIcon.vue'
import BaseTimeAgo from '../../../base/components/BaseTimeAgo.vue'
import { DateTimeService } from 'base/services/DateTimeService'

import NoWidgetAccess from '../../components/NoWidgetAccess.vue'

export default Vue.extend({
  components: {
    BaseIcon,
    BaseTimeAgo,
    NoWidgetAccess
  },
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    }
  },
  computed: {
    ...mapGetters(['getCurrentAlarmId']),
    currentAlarm() {
      return this.$store.state.alarm.items[this.getCurrentAlarmId] || null
    },
    showFullTime() {
      return this.widget?.customSettings?.settings.showFullTime.checked
    },
    currentAlarmVehicles() {
      return this.currentAlarm?.vehicle || []
    },
    clusterVehicles() {
      const clusterVehicles = this.$store.state.cluster.vehicle

      if (this.showOnlyAlarmedVehicles) {
        let alarmedVehicles = {}

        for (const key of this.currentAlarmVehicles) {
          alarmedVehicles[key] = clusterVehicles[key]
        }

        return alarmedVehicles
      }

      return clusterVehicles
    },
    fmsStatusColorMap() {
      const fmsStatusItems = this.$store.state.cluster.fms_status.items
      let colorMap: any = {}

      for (const key in fmsStatusItems) {
        colorMap[key] = fmsStatusItems[key].color_hex
      }

      return colorMap
    },
    columnSorting() {
      return this.widget?.customSettings?.settings?.sortColumns.data.sortedColumns
    },
    vehicleSorting() {
      let sortedVehicleList = this.widget?.customSettings?.settings?.sortVehicles.data.sortedVehicles
      // const diffList = this.widget?.customSettings?.settings?.sortVehicles.data.vehicleDiff

      // if (sortedVehicleList.length > diffList.length) {
      //   console.log('Sorted > Diff')
      //   const diff = sortedVehicleList.filter((elem: string) => !diffList.includes(elem))
      // }

      // if (sortedVehicleList.length < diffList.length) {
      //   const diff = diffList.filter((elem: string) => !diffList.includes(elem))
      // }

      if (this.showOnlyAlarmedVehicles) {
        return this.currentAlarmVehicles
      }

      if (this.showAlarmedVehiclesFirst) {
        for (const key of this.currentAlarmVehicles) {
          sortedVehicleList.splice(sortedVehicleList.indexOf(key.toString()), 1)
          sortedVehicleList.unshift(key.toString())
        }
      }

      return sortedVehicleList
    },
    highlightAlarmedVehicles() {
      return this.widget?.customSettings?.settings?.highlightAlarmedVehicles.checked
    },
    showOnlyAlarmedVehicles() {
      return this.widget?.customSettings?.settings?.showOnlyAlarmedVehicles.checked
    },
    showAlarmedVehiclesFirst() {
      return this.widget?.customSettings?.settings?.showAlarmedVehiclesFirst.checked
    },
    horizontalLayout() {
      return this.widget?.customSettings?.settings?.layoutHorizontal.checked
    },
    layoutHorizontalElementWidth() {
      return this.widget?.customSettings?.settings?.layoutHorizontalElementWidth.value
    },
    fontSize() {
      return this.widget?.customSettings?.settings?.fontSize.value
    },
    fontSizeNoteAndTs() {
      return this.widget?.customSettings?.settings?.fontSizeNoteAndTs.value
    },
    lastColumnRightAligned() {
      return this.widget?.customSettings?.settings?.lastColumnRightAligned.checked
    }
  },
  methods: {
    formatTime(ts: number) {
      return DateTimeService.formatUnixTimestamp(ts)
    }
  }
})
